import React, { Component } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { NewInputText } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Form from "react-bootstrap/Form";
import { TextField } from "@material-ui/core";
import { NOTAVAILABLEIMAGE } from "../../../../../../enums/GlobalEnums";

class OrderEditModelBody extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="superadmin-orderscomponent-main">
          <div className="container-fluid" style={{ marginBottom: "2%" }}>
            <Row>
              <Col md={2}>
                <img src={""} />
              </Col>
              <Col md={6}>
                <h3>McDonald's</h3>
                <h6>Balewadi high street, Pune, India.</h6>
              </Col>
            </Row>
          </div>

          <div
            className="model-head-view-order-detailed "
            style={{
              border: "1px solid #E0E0E0",
              padding: "1%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <div
              style={{
                borderRadius: "5px",
                borderLeft: "5px solid #37ac1e",
                paddingLeft: "1%",
              }}
            >
              <table className="model-view-order-detailed-table">
                <thead>
                  <th style={{ width: "8%" }}>Order Type</th>
                  <th style={{ width: "18%" }}>Name & Request No.</th>
                  <th style={{ width: "10%" }}>No. Items</th>
                  <th style={{ width: "10%" }}>Amount / Payment</th>
                  <th style={{ width: "20%" }}>Seating Preference</th>
                  <th style={{ width: "25%" }}>Date / Time / Timer</th>
                </thead>
                <tbody style={{ marginTop: "1%" }}>
                  <tr>
                    <td>
                      <img
                        src={require("../../../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                        width="35px"
                        alt="Takeaway"
                      />
                    </td>
                    <td>
                      Alexander Petersburg
                      <br />
                      <span style={{ fontSize: ".75rem" }}>#1234567890</span>
                    </td>

                    <td>5</td>
                    <td>
                      ₹ 2200 <br />
                      <span className="badge badge-success">PAID</span>
                      <br />
                      Debit Card
                    </td>
                    <td>-</td>
                    <td>
                      <p
                        style={{
                          color: "#EE3A23",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <span style={{ fontSize: "1.25rem" }}>12:15:22</span>
                        &nbsp;&nbsp;
                        <Button
                          variant="link"
                          className="enIconBtn mr-3 action_icon_padding"
                          // onClick={props.ratingReviewAction}
                        >
                          <Image
                            src={require("../../../../../../assets/images/superadmin/ordericon/Edit.svg")}
                            alt="Rating"
                            title="Rating"
                            fluid
                          />
                        </Button>{" "}
                      </p>

                      <span>29th August 2019 12:15 PM</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr />
            <br />
            <Row>
              <Col md={4}>
                <h5>Order Placed Date & Time</h5>
                <br />
                <p>29th August 2019 | 09:30 PM</p>
              </Col>

              <Col md={2}>
                <h5>User Location</h5>
                <br />
                <center>
                  <img
                    src={require("../../../../../../assets/images/superadmin/ordericon/location_red.svg")}
                    width="25px"
                    alt="location"
                  />
                </center>
              </Col>
              <Col md={6}>
                <h5>Order Notes</h5>
                <div className="f12-400">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.Fusce.
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <br />
          <Row>
            <div className="col-6">
              <Form.Row className="input-component-insideRow mb-4">
                <div className="col-4 col-xl-3 pr-0">
                  <Form.Group controlId={"country_code"}>
                    <div className="input-phone-country-code-reusable w-100">
                      <select
                        name="country_code"
                        className="w-100"
                        // value={this.state.country_code}
                        // onChange={this.onChange}
                      >
                        {/* <option value={this.state.country_code}>
                            {this.state.country_code}
                          </option> */}
                        {getCountries().map((country) => (
                          <option
                            key={country}
                            value={"+" + getCountryCallingCode(country)}
                          >
                            {en[country]} (+
                            {getCountryCallingCode(country)})
                          </option>
                        ))}
                      </select>
                    </div>
                  </Form.Group>
                </div>
                <div className="col-8 col-xl-9">
                  <NewInputText
                    extraClass="mb-0"
                    name="number"
                    inputType="number"
                    // onFocusOut={this.onFocusOut}
                    // onChange={this.onChange}
                    // onKeyDown={InputNumberFunc}
                    // value={this.state.number}
                    maxLength="10"
                    // errorText={
                    //   this.state.number.length > 0 &&
                    //   this.state.number.length <= 9
                    //     ? "Enter valid Mobile Number"
                    //     : null || errors.number === "number is required"
                    //     ? "mobile number is required"
                    //     : null
                    // }
                    // errorTrue={
                    //   (this.state.number.length > 0 &&
                    //     this.state.number.length <= 9) ||
                    //   errors.number === "number is required"
                    //     ? true
                    //     : false
                    // }
                    labelText="Phone Number"
                    // controlClass={
                    //   (this.state.number.length > 0 &&
                    //     this.state.number.length <= 9) ||
                    //   errors.number === "number is required"
                    //     ? "outlined-error-helper-text"
                    //     : "outlined-helperText"
                    // }
                  />
                </div>
              </Form.Row>
            </div>
            <div className="col-6 mb-4">
              <NewInputText
                extraClass="mb-0"
                name="name"
                inputType="name"
                // onFocusOut={this.onFocusOut}
                // onChange={this.handleChange}
                // value={this.state.name}
                // errorText={
                //   !validnameRegex.test(name) && !isEmpty(name)
                //     ? "Please enter a valid name"
                //     : null || errors.name === "name is required"
                //     ? "name is required"
                //     : ""
                // }
                // errorTrue={
                //   (!validnameRegex.test(name) && !isEmpty(name)) ||
                //   errors.name === "name is required"
                //     ? true
                //     : false
                // }
                labelText="Name"
                // controlClass={
                //   (!validnameRegex.test(name) && !isEmpty(name)) ||
                //   errors.name === "name is required"
                //     ? "outlined-error-helper-text"
                //     : "outlined-helperText"
                // }
              />
            </div>
          </Row>
          <br />
          <br />
          <div className="f16-500">Items Added</div>
          <div className="table-responsive">
            <table className="table desc-order-info">
              <tbody>
                <tr>
                  <td style={{ width: "5%" }}>
                    <Image
                      src={require("../../../../../../assets/images/superadmin/ordericon/non veg.svg")}
                      alt="non veg"
                      title="non veg"
                      width="20px"
                      fluid
                    />
                  </td>
                  <td style={{ width: "30%" }}>
                    Chicken Biryani <br />
                    Almond, Cassis
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="d-flex" align="center">
                      <img
                        src={require("../../../../../../assets/images/superadmin/ordericon/add.svg")}
                        width="30px"
                        alt="Add"
                        className="mr-2"
                      />
                      3
                      <img
                        src={require("../../../../../../assets/images/superadmin/ordericon/less.svg")}
                        width="30px"
                        alt="Less"
                        className="ml-2"
                      />
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>₹ 400</td>
                  <td style={{ width: "20%" }}>Edit</td>
                </tr>
              </tbody>
            </table>
          </div>

          <br />

          <button
            style={{
              width: "273px",
              height: "50px",
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              border: "1px solid #EE3A23",
              boxShadow: "0px 3px 6px #6E6E6E21",
              borderRadius: "5px",
            }}
          >
            Add Another Item
          </button>
          <br />
          <br />
          <TextField
            variant="outlined"
            fullWidth
            label="Kitchen Notes"
            multiline
            rows={3}
          />
          <br />
          <div className="d-flex align-items-center pt-5">
            <Button
              variant="outline-secondary"
              className="mr-4 px-5 py-2"
              //   onClick={(e) => this.props.history.push("/superadminorders")}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="px-5  py-2"
              //onClick={(e) => handleShowTab("2")}
              //type="submit"
              //   onClick={() => onClickStepOne()}
            >
              Update
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OrderEditModelBody;
